import {inject, Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {UrlService} from "./url.service";
import {UrlEnum} from "../types/url-enum";
import {BehaviorSubject, finalize, forkJoin, Observable, tap} from "rxjs";
import {ClinicInfo} from "../types/clinic.types";
import {ImgService} from "./img.service";
import {Discipline} from "../../features/home/components/treatment-management/treatment.types";

@Injectable({providedIn: 'root'})
export class ClinicInfoService {
    private _httpClient:HttpClient = inject(HttpClient);
    private _urlService: UrlService = inject(UrlService);
    private _imgService: ImgService = inject(ImgService);

    //observables
    private readonly _clinicInfo: BehaviorSubject<ClinicInfo | null> = new BehaviorSubject(null);
    private readonly _busy: BehaviorSubject<boolean> = new BehaviorSubject(false);

    get busy$() {
        return this._busy.asObservable();
    }

    get clinicInfo$(): Observable<ClinicInfo> {
        return this._clinicInfo.asObservable();
    }

    get clinicInfo(): ClinicInfo {
        return this._clinicInfo.value;
    }

    public getClinicInfo(useCache:boolean){
        if(useCache && this._clinicInfo.value?.name){
            return;
        }
        this._busy.next(true);
        const clinicInfoObs:Observable<ClinicInfo> = this._httpClient.get<ClinicInfo>(this._urlService.getUrl(UrlEnum.private_clinic));
        const disciplinesObs:Observable<Discipline[]>= this._httpClient.get<Discipline[]>(this._urlService.getUrl(UrlEnum.private_disciplines));
        forkJoin([clinicInfoObs,disciplinesObs]).pipe(
            tap(value => {
                this.updateClinicLogo(value[0]).then(logoUpdatedValue => {
                    logoUpdatedValue.managedDisciplines = value[1];
                    this._clinicInfo.next(logoUpdatedValue);
                })
            }),
            finalize(() => {
                this._busy.next(false);
            })
        ).subscribe()
    }

    public updateClinicInfo(info: ClinicInfo){
        this._busy.next(true);
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        return this._httpClient.put<string>(this._urlService.getUrl(UrlEnum.private_clinic_update).replace('{id}', info.id), JSON.stringify(info), {headers: headers}).pipe(tap(result => {
            this._clinicInfo.next(info);
        }), finalize(() => {
            this._busy.next(false)
        }));
    }

    private async updateClinicLogo(clinic:ClinicInfo): Promise<ClinicInfo> {
        //update
        if (clinic?.logoLocation) {
            const img:Blob = await this._imgService.getClinicLogo(clinic);
            if(img != null){
                this._imgService.setClinicLogoFromBlob(clinic, img);
            }
        }
        return clinic;
    }

    getDisciplineByID(id:string){
        return this.clinicInfo.managedDisciplines.find(d => d.id === id);
    }

}



